import { MouseEvent } from 'react';

export const handleTbodyMouseDown = (
  e: MouseEvent<HTMLTableSectionElement>
): void => {
  // Native double click text selection would flash before the row submit-and-close (onRowDoubleClick) runs.
  if (e.detail > 1) {
    e.preventDefault();
  }
};
